// noinspection GraphQLUnresolvedReference

import { gql, GraphQLClient } from 'graphql-request'

import { AccessToken } from '../../../base/models/paramsModel'
import { MyGraphQlError } from '../../../base/services/GraphqlError'
import { AlmacenOutputProps, AlmacenProp } from '../interfaces'

const query = gql`
  mutation ALMACEN_ACTUALIZAR($codigoAlmacen: String!, $input: AlmacenInput!) {
    almacenActualizar(codigoAlmacen: $codigoAlmacen, input: $input) {
      nombre
      ubicacion
      sucursal {
        codigo
        telefono
      }
    }
  }
`

/**
 * Actualización de un almacen
 * @param codigoAlmacen
 * @param input
 */
export const apiAlmacenActualizar = async (
  codigoAlmacen: string,
  input: AlmacenOutputProps,
): Promise<AlmacenProp> => {
  try {
    const client = new GraphQLClient(import.meta.env.ISI_API_URL)
    const token = localStorage.getItem(AccessToken)
    // Set a single header
    client.setHeader('authorization', `Bearer ${token}`)

    const data: any = await client.request(query, {
      codigoAlmacen,
      input,
    })
    return data.almacenActualizar
  } catch (e: any) {
    throw new MyGraphQlError(e)
  }
}
